


export function InstrucoesSerrote() {

    return (
        <div className="text-lg">
            <div ><span className="font-bold">1.</span> Consulte a escala de trabalho (gráfico gant)</div>
            <hr className="mb-5" />
            <div><span className="font-bold">2.</span> Consulte dados da obra em APPRodrimaq&gt;Obras&gt;Data de entrega xxx&gt;Serrote</div>
            <hr className="mb-5" />
            <div className="mb-2"><span className="font-bold">3.</span> Proceda à preparação do material para a execução da obra</div>
            <div className="ml-10">
                <div className="mb-2"><span className="font-bold">a.</span> Consulte a nota de encomenda e separe o material encomendado associado à obra/ ou / corte
                    matéria prima consoante disponibilidade no inventário de stock, e, logo após, este último deverá ser
                    atualizado;</div>
                <div><span className="font-bold">b.</span> Deve identificar os brutos com as referências das peças em caixa com identificação da obra e colocar
                    na estante central;</div>
            </div>
            <hr className="mb-5" />
            <div ><span className="font-bold">4.</span> Nos momentos menos exigentes, proceda à inventariação de stock;</div>
            <hr className="mb-5" />
            <div ><span className="font-bold">5.</span> Acompanhe, sempre que possível, as ocorrências de corte urgente em tempo útil;</div>
            <hr className="mb-5" />
        </div>
    )

}